import { Box, Button, Stack } from '@mui/material';
import { Disbursement } from 'api';
import Input from 'components/Input';
import useForm from 'js/hooks/useForm';
import React from 'react'
import { useParams } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap'

// $field_name is required
// Actual Disbursement is required

const today = new Date().toISOString().split('T')[0];

const schema = [
    {
        label: "Actual Disbursement Amount (₹)",
        name: "disbursed_amt",
        type: "number",
        error: { required: true, name: "Actual Disbursement" }
    },
    {
        label: "Actual Disbursement Date",
        name: "disbursed_date",
        type: "date",
        max: today,
        error: { required: true }
    },
    {
        label: "Disbursement Info",
        name: "disbursement_txn_info",
        type: "textarea",
        error: { required: true }
    },
]

export default function AddDisbursement({ payload, onClose }) {
    console.log('payload: ', payload);

    const { data, values, inputProps, isError, setData, setTouched } = useForm({ schema, payload })
    const { id: case_id } = useParams()
    const id = payload?.id
    const onCancel = () => {
        setData({})
        onClose()
    }

    const onSubmit = async () => {
        if (isError()) {
            setTouched(true)
            return
        }

        try {
            const res = await Disbursement.putById({ id, case_id, payload: values })
            onClose(res)
            setData({})
        } catch (error) {
            alert(error.message)
        }
    }

    return (
        <Modal isOpen={payload} toggle={onCancel}>
            <Stack direction={'row'} gap={2} sx={{ borderBottom: "1px solid #0003", px: 2, pt: 1 }}>
                <h3>#{id}</h3>
                <h3>Disbursement</h3>
            </Stack>
            <ModalBody>
                <Stack spacing={2}>
                    {schema.map(d => <Input {...inputProps(d)} />)}
                    <Stack flexDirection={"row"} justifyContent={"space-between"}>
                        <Button onClick={onCancel} variant='outlined' color='error'>Cancel</Button>
                        <Button onClick={onSubmit} variant='contained'>Submit</Button>
                    </Stack>
                </Stack>
            </ModalBody>
        </Modal>
    )
}
